module.exports = __webpack_public_path__ + "img/tips.12cbf674.svg";